<bpt-top-bar *ngIf="iseQMSApp" [title]="topBarTitle" [userPuid]="loggedInUser | uppercase" [showCurrentLocation]="false">
</bpt-top-bar>
